import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;

export function LRViewSignatureBlock({ title }) {
	return (
		<>
			<Row justify="center" align="center">
				<Col>
					<Text strong>{title}</Text>
				</Col>
			</Row>
			<Row justify="center" align="center">
				<Col>
					<div
						style={{
							display: 'flex',
							minHeight: '150px',
							minWidth: '300px',
							width: '100%',
							border: ' 0.1px dashed black',
							padding: '2px',
							color: 'rgba(12,12,12,0.3)',
							justifyContent: 'center',
							alignItems: 'center',
							fontSize: '20px',
						}}
					>
						Seal
					</div>
				</Col>
			</Row>
			<Row justify="center" align="center">
				<Col>
					<div
						style={{
							display: 'flex',
							minHeight: '60px',
							minWidth: '300px',
							width: '100%',
							border: ' 0.1px dashed black',
							padding: '2px',
							color: 'rgba(12,12,12,0.3)',
							justifyContent: 'center',
							alignItems: 'center',
							fontSize: '14px',
						}}
					>
						Signature
					</div>
				</Col>
			</Row>
		</>
	);
}

LRViewSignatureBlock.propTypes = {
	title: PropTypes.string,
};
